// Компонент кнопки

import type { ButtonProps } from '../../types';
import './Button.css';

export function Button({
  children,
  onClick,
  variant = 'primary',
  size,
  icon,
  disabled = false,
  type = 'button',
  className = '',
}: ButtonProps) {
  const classes = [
    'button',
    `button--${variant}`,
    size && `button--${size}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type={type}
      className={classes}
      onClick={onClick}
      disabled={disabled}
    >
      {icon && <span className="button__icon">{icon}</span>}
      {children}
    </button>
  );
}
